/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED REACT QUERY HOOKS - DO NOT EDIT
 * Generated from: MerchantRedemptionContract
 */

import { merchantredemptionApi } from '../api/merchantredemption.api';
import { createMutationHook, createPaginatedQueryHook } from './base.hooks';
import { queryKeys } from './query-keys';
import type { CreateRedemptionBodyType, CreateRedemptionParamsType, CreateRedemptionResponseType, ListRedemptionsQueryType, ListRedemptionsParamsType, ListRedemptionsResponseType, CheckCashierCodeBodyType, CheckCashierCodeParamsType, CheckCashierCodeResponseType, CheckCouponCodeBodyType, CheckCouponCodeParamsType, CheckCouponCodeResponseType } from '@zlinkx/shared-v2';
import type { HookOptions, MutationHookReturn, QueryHookReturn } from '@/types/hook-generated.types';

export const useCreateRedemption = createMutationHook<CreateRedemptionResponseType['data'], { merchantId: CreateRedemptionParamsType['merchantId']; data: CreateRedemptionBodyType }>(
  (params) => merchantredemptionApi.createRedemption(params.merchantId, params.data),
  {
    queryKey: queryKeys.merchantredemption.all,
  }
);

export const useListRedemptions = createPaginatedQueryHook<ListRedemptionsResponseType['data'][number], { merchantId: ListRedemptionsParamsType['merchantId']; query?: ListRedemptionsQueryType }>(
  ({ merchantId, query }) => merchantredemptionApi.listRedemptions(merchantId, query),
  ({ merchantId, query }) => queryKeys.merchantredemption.listRedemptions(merchantId, query)
);

export const useCheckCashierCode = createMutationHook<CheckCashierCodeResponseType['data'], { merchantId: CheckCashierCodeParamsType['merchantId']; data: CheckCashierCodeBodyType }>(
  (params) => merchantredemptionApi.checkCashierCode(params.merchantId, params.data),
  {
    queryKey: queryKeys.merchantredemption.all,
  }
);

export const useCheckCouponCode = createMutationHook<CheckCouponCodeResponseType['data'], { merchantId: CheckCouponCodeParamsType['merchantId']; data: CheckCouponCodeBodyType }>(
  (params) => merchantredemptionApi.checkCouponCode(params.merchantId, params.data),
  {
    queryKey: queryKeys.merchantredemption.all,
  }
);